module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAIAAAAnX375AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQdJREFUeNrs2DtvwjAUhmH7IKVJRGCgARTaAVX9/z+oqjqUewJSYhSboCT9UNVSlQVxOQz43eIhj2ydxZZ1XYufjNnEyVKpda7N3/XTklL6nhsEzfCx47oP+/XfX8/m8Xgyq6pKXDoiGkT9fi/ck+jt/SNNlbhm7Xbw+jLE1gkfn6PJtT0EYjSe7jattVnES8HSfJFoYwjzcv6kHBmgJFlRminBGDgqNgUnWRRbqrhO9buyLEmwZ0lLWtKSlrSkJS15VyRJyek1GkSO43CS4AgXIk6yFTQJ903JdbaAwJHnud2ww0MCAreb2OeniOF4QQC63cX93/NEptZ5ri+C+b7XOnie+BJgAB6yezmQwfEkAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/icon/app-ico.png
// module id = w2hd
// module chunks = 39 44